import { getLogger } from '../logger';

export type IntercomEventMetadata = { readonly [key: string]: unknown };
export type IntercomEventDispatcher = (eventName: string, meta?: IntercomEventMetadata) => void;

const logger = getLogger('intercomTracker');

export let logEvent: IntercomEventDispatcher = (_eventName, _meta) =>
  logger.warn('IntercomTracker not initialized for client');
// logEvent function should expect 'eventName' and 'meta' props after being initialized

export const registerEventDispatcher = (func: IntercomEventDispatcher): void => {
  logEvent = (eventName, meta) => {
    logger.log('Tracking Intercom Event:', eventName);
    func(eventName, meta);
  };
};
